import { Pipe, PipeTransform } from '@angular/core';
import { Vehicle } from 'src/app/shared/models/vehicle';

@Pipe({
	name: 'filterVehiculeByTravelledDistanceBetween'
})
export class FilterVehiculeByTravelledDistanceBetweenPipe
	implements PipeTransform
{
	transform(value: Vehicle[], min?: number, max?: number): Vehicle[] {
		if (
			value === null ||
			((min === null || min <= 0) && (max === null || max === 0))
		) {
			return value;
		}
		if (min === null) {
			min = Math.max();
		}
		if (max === null) {
			max = Math.min();
		}

		if (min >= max) {
			return null;
		}

		return value.filter(
			(vehicule) =>
				vehicule.travelledDistance >= min && vehicule.travelledDistance <= max
		);
	}
}
